import styled, { css } from "styled-components";

const padding = 32;

export const Container = styled.div<{
  width: number;
  position: "left" | "right";
}>`
  position: absolute;
  z-index: 99;
  background-color: ${({ theme }) => theme.colorTokens.background.surface};
  border: 1px solid ${({ theme }) => theme.colorTokens.background.infoSubtle};
  box-shadow: 0 2px 4px rgb(17 43 68 / 18%);
  border-radius: 4px;
  width: max-content;
  min-width: ${({ width }) => `${width + 2}px`};
  ${({ position }) =>
    position === "right"
      ? css`
          right: 0;
        `
      : css`
          left: 0;
        `};

  /* Set dropdown width to viewport width if dropdown is larger than the window width */
  @media screen and (max-width: ${({ width }) => `${width + padding}px`}) {
    min-width: calc(100vw - ${padding}px);
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
`;
